import { SVGProps } from 'react';

const ConeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 61 82"
    {...props}
  >
    <path fill="#E76F4C" d="M8.227 75.91 25.954 0h9.545l17.728 75.91h-45Z" />
    <path
      fill="#F4F4F4"
      d="M40.595 21.818H20.857L17.99 34.091h25.466l-2.86-12.273ZM46.325 46.364h-31.2l-2.863 12.272h36.933l-2.87-12.272Z"
    />
    <path fill="#000" fillOpacity={0.05} d="M30.045 75.91 31.18 0h3.41l11.59 75.91H30.045Z" />
    <path fill="#000" fillOpacity={0.08} d="M46.182 75.91 34.59 0h.909l17.727 75.91h-7.045Z" />
    <path
      fill="#fff"
      fillOpacity={0.1}
      d="M12.318 69.773 26.864 0h.909L15.046 69.773h-2.728ZM48.455 68.636 33.909 0h.91l15.226 68.636h-1.59Z"
    />
    <path fill="#DB6948" d="M7.318 75.909h46.818v.909H7.318z" />
    <path fill="#312C25" d="M.5 76.818h60v4.545H.5z" />
    <path fill="#fff" fillOpacity={0.3} d="M.5 76.818h60v.909H.5z" />
    <path fill="#000" fillOpacity={0.3} d="M.5 80.454h60v.909H.5z" />
  </svg>
);
export default ConeIcon;
